import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LandingService {

  apiBaseUrl = environment.baseApiUrl;
  private selectedClientSource = new BehaviorSubject<string>('Choose Client');
  selectedClient$ = this.selectedClientSource.asObservable();
  private selectedStudySource = new BehaviorSubject<string>('Study Name');
  selectedStudy$ = this.selectedStudySource.asObservable();
  private alertAccessSource = new BehaviorSubject<boolean>(false);
  alertAccess$ = this.alertAccessSource.asObservable();

  private getAlertAccessKey(client: string, study: string): string {
    return `alertAccess_${client}_${study}`;
  }

  setAlertAccess(value: boolean, client: string, study: string) {
    const key = this.getAlertAccessKey(client, study);
    sessionStorage.setItem(key, JSON.stringify(value));
    this.alertAccessSource.next(value);
  }

  getAlertAccess(client?: string, study?: string): boolean {
    const c = client || this.getSelectedClient();
    const s = study || this.getSelectedStudy();
    const stored = sessionStorage.getItem(this.getAlertAccessKey(c, s));
    return stored ? JSON.parse(stored) : false;
  }

  constructor(private http: HttpClient) { }

  getlandingAllClientList(): Observable<any> {
    return this.http.get<any>(this.apiBaseUrl + "api/LandingPage/getlandingDataAllClientList").pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        // You can handle the error here and throw a custom error if needed
        return throwError(error);
      })
    );
  }

  getlandingClientList(moduleName:string): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('moduleName', moduleName);
    return this.http.post<any>(this.apiBaseUrl + "api/LandingPage/getlandingData",formData).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        // You can handle the error here and throw a custom error if needed
        return throwError((error:any) => new Error(error));
      })
    );
  }

  getSnapshotlandingClientList(): Observable<any> {
    return this.http.get<any>(this.apiBaseUrl + "api/LandingPage/getSnapshotlandingData").pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        // You can handle the error here and throw a custom error if needed
        return throwError(error);
      })
    );
  }

  getAllLandingClientList(): Observable<any> {
    return this.http.get<any>(this.apiBaseUrl + "api/LandingPage/getCombinedLandingData").pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        // You can handle the error here and throw a custom error if needed
        return throwError(error);
      })
    );
  }

  setSelectedClient(clientName: string) {
    this.selectedClientSource.next(clientName);
  }

  setSelectedStduy(studyName: string) {
    this.selectedStudySource.next(studyName);
  }

  getSelectedClient(): string {
    return this.selectedClientSource.getValue();
  }

  getSelectedStudy(): string {
    return this.selectedStudySource.getValue();
  }
}
